module.exports = __webpack_public_path__ + "img/comp_larry.354a67b1.png";